module.exports = __webpack_public_path__ + "img/cn.6d4a44e2.png";